module.exports = __webpack_public_path__ + "img/tenaya-lake-1.cac6d30f.jpg";